'use client';

/* ============================================================
   BoardLanding — the masthead and site nav that wrap the connect form.

   Design intent: this is NOT a separate page you click through to reach
   the board. The connect form IS the landing page; this component just
   supplies what sits above and below it, so a first-time visitor sees the
   logo, one line of copy, and the username field without navigating.

   The logo is black line-art on an opaque white plate, so on the board's
   near-black shell it gets its own light panel. That reads as a placard
   mounted on the board rather than a broken transparent PNG -- which is
   the right metaphor anyway.

   The nav deliberately does NOT re-explain the product. The board is
   self-evident once it's on screen; the copy's whole job is to get
   someone to type their username.
   ============================================================ */

const AMBER = '#ffb300';
const DIM = '#5c6068';

export function BoardMasthead({ compact = false }) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 18,
        marginBottom: 30,
        textAlign: 'center',
      }}
    >
      <img
        src="/webheader.png"
        alt="Buttfumbles — Fantasy Football Public Information Board"
        style={{
          width: compact ? 150 : 190,
          height: 'auto',
          background: '#fff',
          borderRadius: 14,
          padding: 10,
          boxShadow: '0 10px 34px -12px rgba(0,0,0,.9), 0 0 0 1px #1b1e23',
        }}
      />
      {/* The page's <h1>. It is the tagline rather than the logo because the
          logo is an <img> whose alt is just the brand name, while this line
          actually says what the page is. LeagueSetup's "CONNECT YOUR LEAGUE"
          was demoted to <h2> to make room -- it labels a section of this
          page, not the page itself.

          fontWeight is pinned to 400: <p> defaults to normal and <h1> to
          bold, so without it this silently renders bold. Every other style
          here was already explicit. */}
      <h1
        style={{
          color: '#c8cbd0',
          fontSize: compact ? 14 : 15,
          fontWeight: 400,
          lineHeight: 1.55,
          letterSpacing: '.02em',
          margin: 0,
          maxWidth: 430,
        }}
      >
        Sync your Sleeper® fantasy football league and display the situation
        in your home, office or dorm.
      </h1>
    </div>
  );
}

export function SiteFooter({ onNavigate }) {
  const go = (hash) => (e) => {
    e.preventDefault();
    if (onNavigate) onNavigate(hash);
    else window.location.hash = hash;
  };

  return (
    <div
      style={{
        marginTop: 34,
        paddingTop: 18,
        borderTop: '1px solid #14161a',
        width: '100%',
        maxWidth: 460,
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 4,
      }}
    >
      <FooterLink href="#how" onClick={go('how')}>HOW IT WORKS</FooterLink>
      <Dot />
      <FooterLink href="#generate" onClick={go('generate')}>FAKE NAME GENERATOR</FooterLink>
      <Dot />
      <FooterLink href="#play" onClick={go('play')}>STARTING FIVE GAME</FooterLink>
      <Dot />
      <FooterLink href="#protocol" onClick={go('protocol')}>THE PROTOCOL GAME</FooterLink>
      <Dot />
      <FooterLink href="#legal" onClick={go('legal')}>PRIVACY &amp; TERMS</FooterLink>
    </div>
  );
}

function FooterLink({ href, onClick, children }) {
  return (
    <a
      href={href}
      onClick={onClick}
      style={{
        color: DIM,
        fontSize: 10,
        letterSpacing: '.18em',
        fontWeight: 700,
        textDecoration: 'none',
        padding: '5px 7px',
        whiteSpace: 'nowrap',
      }}
      onMouseEnter={(e) => { e.currentTarget.style.color = AMBER; }}
      onMouseLeave={(e) => { e.currentTarget.style.color = DIM; }}
    >
      {children}
    </a>
  );
}

function Dot() {
  return <span style={{ color: '#22252a', fontSize: 10 }}>·</span>;
}

export default BoardMasthead;
